import React from "react";
import "./trafficLightIndicator.css";

const TrafficLightIndicatorBurnoutCynicism = ({ category, riskLevel, recommendation }) => {
  let textRisk = ""
  // Asignar color según el nivel de riesgo
  const getColor = (level) => {
    switch (level) {
      case 0:
        textRisk = "Baja"
        return "green";
      case 1:
        textRisk = "Media"
        return "yellow";
      case 2:
        textRisk = "Alta"
        return "red";
      default:
        return "gray";
    }
  };

  return (
    <div className="traffic-light-indicator">
      <h3 className="category-title">{category}</h3>
      <div className={`traffic-light ${getColor(riskLevel)}`}>
        {textRisk}
      </div>
      <p className="recommendation">{recommendation}</p>
    </div>
  );
};

export default TrafficLightIndicatorBurnoutCynicism;
